import React from "react";
import Loader from "@/modules/shared/ui/Loader";
import { connect } from "react-redux";

import type { ReduxState } from "@/modules/pg/shared/planningTable/reducers/reducers";
import type { ReportState } from "@/modules/pg/shared/planningTable/reducers/report";

type OwnProps = {};
type Props = OwnProps & ReduxProps;

const getReportCreatedAt = (report: ReportState) => {
    if (!report || !report.report_data) return null;
    return report.report_data.created_at;
};

const ReportLoader = ({ report_created_at, report_loading, report_loading_message }: Props) => {
    const show_loading = !report_created_at || report_loading;
    let style: React.CSSProperties = { display: "none" };

    if (show_loading) {
        style = {
            backgroundColor: "white",
            opacity: "0.85",
            position: "absolute",
            inset: 0,
            zIndex: 1000,
            display: "unset",
        };
    }

    return <div style={style}>{show_loading && <Loader message={report_loading_message} />}</div>;
};

const mapState = (state: ReduxState) => {
    const report = state.gantt_chart_report;
    return {
        report_loading: report.report_loading,
        report_loading_message: report.report_loading_message,
        report_created_at: getReportCreatedAt(report),
    };
};

type ReduxProps = ReturnType<typeof mapState>;

export default connect<ReturnType<typeof mapState>, {}, OwnProps, ReduxState>(mapState)(ReportLoader);
